import React from "react";

import { TsicommonCmsLinkOrNull } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import sharedStyles from "../shared.module.scss";
import styles from "./index.module.scss";

export const RichNavigationLink = (
    props: Exclude<TsicommonCmsLinkOrNull, null>,
): React.JSX.Element => {
    return (
        <a
            className={concatClassNames([
                sharedStyles.hoverEffect,
                styles.link,
            ])}
            href={props.url}
        >
            {props.title}
        </a>
    );
};
